<template>
  <section class="hero is-primary is-fullheight-with-navbar">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">Ops!</h1>
        <h2 class="subtitle">Non dovresti essere qui.</h2>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "forbidden"
};
</script>
